import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BASE_CONSTANTS, BASE_URLS, TCITenantSelectorType, TCIToolDownloadType } from "@tci/common";
import { Subscription } from "rxjs";
import { NgToastrService } from "../../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import { ITCIEnvToolsAgentCreateMenuOutput } from "../../ng-tenant/tci-tenant-components";
import { BaseUnifiedManagementDownloadService } from "./base-unified-management-download.service";
import { AbstractTCITenantComponent } from "../../ng-tenant/tci-tenant-component";
import { BaseEnvToolsAgentCreateMenuComponentInput, BaseEnvToolsAgentCreateMenuComponentOutput } from "../base-agent/base-agent-menu";

@Component({
    selector: TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_UNIFIED_MGMT.toString(),
    templateUrl: "./base-unified-management-download.component.html",
    styleUrls: ["./base-unified-management-download.component.less"]
})
export class BaseUnifiedManagementDownloadComponent<E, I extends BaseEnvToolsAgentCreateMenuComponentInput,
    O extends BaseEnvToolsAgentCreateMenuComponentOutput<ITCIEnvToolsAgentCreateMenuOutput>>
    extends AbstractTCITenantComponent<E, I, EventEmitter<ITCIEnvToolsAgentCreateMenuOutput>>
    implements OnInit, OnDestroy {

    @Output() output: EventEmitter<ITCIEnvToolsAgentCreateMenuOutput> = new EventEmitter();

    private subscriptions: Subscription[] = [];
    isPreparingDownload = false;
    loadingText = "Preparing download...";
    buttonLabel;

    constructor(
        private translate: TranslateService,
        private toastr: NgToastrService,
        private baseUnifiedManagementDownload: BaseUnifiedManagementDownloadService
    ) {
        super();
    }

    ngOnInit() {
        this.buttonLabel = this.baseUnifiedManagementDownload.defaultFilename();
        // TODO: Update ng-env-tools.lang.json for unified management info
        this.subscriptions.push(
            this.baseUnifiedManagementDownload.getProductVersion()
            .subscribe(data => {
                if (data?.version) {
                    this.buttonLabel += " | " + data?.version;
                }
                if (data?.date) {
                    this.buttonLabel += " | " + this.formatDate(data?.date);
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    public download() {
        const url = `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.TOOLS}/${TCIToolDownloadType.agent_ext}`;

        this.isPreparingDownload = true;
        this
            .subscriptions
            .push(
                this
                    .baseUnifiedManagementDownload
                    .download(url, "linux", "amd64")
                    .subscribe(
                        () => {
                            this.isPreparingDownload = false;
                        },
                        error => {
                            console.log(error);
                            this.toastr.error("Failed to download unified management tool.");
                        }
                    )
            );
    }

    public cancel() {
        this.closeModal(false);
    }

    protected closeModal(refresh: boolean): ITCIEnvToolsAgentCreateMenuOutput {
        const e: ITCIEnvToolsAgentCreateMenuOutput = {
            closeModal: true,
            refresh
        };
        this.output.emit(e);
        return e;
    }

    public formatDate(dateTimeString) {
        return new Date(dateTimeString.replace(/UTC/, "Z")).toLocaleDateString();
    }

}
